import { useState, useCallback, useMemo } from 'react';
import { FileType } from 'entities/Files/types';

export const useFileSelection = (currentPageFiles: FileType[]) => {
	const [selectedFiles, setSelectedFiles] = useState<string[]>([]);

	const currentPageFileIds = useMemo(() => currentPageFiles.map((f) => f._id), [currentPageFiles]);

	const isAllSelected = useMemo(
		() => currentPageFileIds.length > 0 && currentPageFileIds.every((id) => selectedFiles.includes(id)),
		[currentPageFileIds, selectedFiles],
	);

	const isIndeterminate = useMemo(
		() => selectedFiles.length > 0 && !isAllSelected,
		[selectedFiles, isAllSelected],
	);

	const handleToggleFile = useCallback((fileId: string) => {
		setSelectedFiles((prev) =>
			prev.includes(fileId) ? prev.filter((id) => id !== fileId) : [...prev, fileId],
		);
	}, []);

	const handleToggleAllFiles = useCallback(
		(refresh?: boolean) => {
			setSelectedFiles((prev) => {
				if (refresh) return [];
				const allCurrentSelected = currentPageFileIds.every((id) => prev.includes(id));
				if (allCurrentSelected) {
					return prev.filter((id) => !currentPageFileIds.includes(id));
				}
				const newIds = currentPageFileIds.filter((id) => !prev.includes(id));
				return [...prev, ...newIds];
			});
		},
		[currentPageFileIds],
	);

	const resetSelection = useCallback(() => setSelectedFiles([]), []);

	return {
		selectedFiles,
		isAllSelected,
		isIndeterminate,
		handleToggleFile,
		handleToggleAllFiles,
		resetSelection,
	};
};
